import GiftInfo from '@activities/gift/_shared/components/GiftInfo';
import RefundButton from '@activities/gift/GiftSentActivity/components/RefundButton';
import Accordion from '@components/Accordion';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import Loading from '@components/Loading';
import useGiftBox from '@hooks/gift/useGiftBox';
import { GiftBoxType, GiftCouponStatus, GiftItemType } from '@models/gift';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import dayjs from 'dayjs';
import { Fragment, useMemo } from 'react';

import PurchaseInfo from './components/PurchaseInfo';

interface Params {
    giftBoxItemId: string;
    giftItemType: GiftItemType
}

const GiftSentActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { giftBoxItemId, giftItemType } = params;
  const giftBox = useGiftBox(giftBoxItemId, {
    giftItemType, giftBoxType: GiftBoxType.SENT,
  });
  const isCancelable = useMemo(() => {
    if (!giftBox) return false;
    // 7일 이전의 선물만 취소 가능
    const spent = dayjs().diff(dayjs(giftBox?.createdAt), 'days');
    return giftBox.giftCoupon?.status === GiftCouponStatus.ISSUED
          && spent <= 7;
  }, [giftBox]);
  return (
      <AppScreen>
          <CtaLayout header={<Header title='보낸 선물' />}
                     footer={isCancelable ? <RefundButton giftBoxItemId={giftBoxItemId}
                                                          giftItemType={giftItemType}/>
                       : undefined}>
              {giftBox ? (
                  <Fragment>
                      <GiftInfo giftBox={giftBox}/>
                      <PurchaseInfo giftBox={giftBox}/>
                  </Fragment>
              ) : <Loading/>}
              <Divider/>
              <Accordion title='유의사항' >
                  유의사항 어쩌구 저쩌구<br/>
                  유의사항 어쩌구 저쩌구<br/>
                  유의사항 어쩌구 저쩌구<br/>
                  유의사항 어쩌구 저쩌구<br/>
                  유의사항 어쩌구 저쩌구<br/>
                  유의사항 어쩌구 저쩌구
              </Accordion>
          </CtaLayout>
      </AppScreen>
  );
};

export default GiftSentActivity;
